/* eslint-disable react/jsx-no-duplicate-props */
import { memo, ChangeEvent } from "react";
import TextField from "@mui/material/TextField";
import CustomErrorText from "../CustomErrorText";

interface Props {
  className?: string;
  inputClassName?: string;
  label: string;
  onChange: (e: ChangeEvent<any>) => void;
  value: string;
  name: string;
  touched?: boolean;
  error?: string;
  handleBlur: (event: any) => void;
  requiredStar?: boolean;
  disabledField?: boolean;
  maxLength?: number;
}
function CustomTextField({
  className,
  label,
  inputClassName,
  onChange,
  value,
  name,
  touched,
  error,
  handleBlur,
  requiredStar,
  disabledField,
  maxLength
}: Props) {
  return (
    <div className={`${className}`}>
      <div className="rounded-lg bg-white border border-solid border-discoBall focus-within:border-2 focus-within:border-hotShot">
        <TextField
          fullWidth
          disabled={disabledField}
          required={requiredStar}
          variant="filled"
          label={label}
          onBlur={handleBlur}
          type={name === "password" ? "password" : "text"}
          InputProps={{
            classes: {
              input:
                "!text-sm !leading-5 !font-medium !text-black !bg-white !rounded-lg !font-montserrat",
              root: `!rounded-lg ${inputClassName}`,
              disabled: "!bg-gray-200"
            },
            disableUnderline: true
          }}
          InputLabelProps={{
            classes: {
              root: "!text-sm !leading-5 !font-medium !text-platinumGranite !font-montserrat !pt-0.5 !pb-2",
              shrink: "!text-purpleComet !text-xs"
            }
          }}
          inputProps={{ maxLength }}
          onChange={onChange}
          value={value}
          name={name}
        />
      </div>
      {touched && error && <CustomErrorText text={error} type="error" />}
    </div>
  );
}

CustomTextField.defaultProps = {
  className: "",
  inputClassName: "",
  requiredStar: false,
  touched: "",
  error: "",
  disabledField: false,
  maxLength: 500
};

export default memo(CustomTextField);
